import Const from 'const';
import {PlayerTeamStackingInterface} from 'components/molecules/player-team-stacking/player-team-stacking-interface';

class PlayerTeamStacking implements PlayerTeamStackingInterface {
    constructor(public readonly checkedPlayers: object = {}) {}
    public isOnlyInTeamStackingUsed(playerId: number): boolean {
        return this.checkedPlayers.hasOwnProperty(playerId) && this.checkedPlayers[playerId];
    }
    public getRestrictedPlayerIds(): number[] {
        return Object.keys(this.checkedPlayers).map(Number);
    }
}

const playerTeamStacking = new PlayerTeamStacking();

export default function players(state = playerTeamStacking, action) {
    switch (action.type) {
        case Const.NON_CONTROLLED_HITTER_STACKING_SET_RESTRICT_PLAYERS: {
            const {checkedPlayers} = action;

            return new PlayerTeamStacking(checkedPlayers);
        }
        case Const.LOCKING_SET_PLAYERS: {
            const checkedPlayers = state.checkedPlayers;

            Object.values(action.items).map((modes) => {
                if (typeof modes !== 'object' || modes === null) {
                    return;
                }

                Object.keys(modes).map((playerId) => {
                    if (Boolean(modes[playerId]) && checkedPlayers.hasOwnProperty(playerId)) {
                        delete checkedPlayers[playerId];
                    }
                });
            });

            return new PlayerTeamStacking(checkedPlayers);
        }
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new PlayerTeamStacking();

        default:
            return state;
    }
}
